import { render, staticRenderFns } from "./menu-main.vue?vue&type=template&id=750a3021&scoped=true&"
import script from "./menu-main.vue?vue&type=script&lang=ts&"
export * from "./menu-main.vue?vue&type=script&lang=ts&"
import style0 from "./menu-main.vue?vue&type=style&index=0&id=750a3021&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750a3021",
  null
  
)

export default component.exports